import React from 'react';
import { FC, useId } from 'react';
import theme from 'src/shared/theme';
import styled from 'styled-components';

const _sparkles: FC<{ className?: string }> = ({ className }) => {
    // Unique ids per instance: the gradient/clip ids used to be hardcoded, so multiple Sparkles in the DOM
    // (e.g. a list of buttons plus a hidden editor) shared the same ids. When one instance unmounted, the
    // others lost their referenced defs and the icon flickered away. useId keeps every instance self-contained.
    const uid = useId().replace(/:/g, '');
    const paint0 = `sparkles_paint0_${uid}`;
    const paint1 = `sparkles_paint1_${uid}`;
    const paint2 = `sparkles_paint2_${uid}`;
    const clip = `sparkles_clip_${uid}`;

    return (
        <svg className={className} xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <g clipPath={`url(#${clip})`}>
                <path
                    d='M8.48438 0.75C8.48438 6.68775 5.2755 12 0.75 12C5.2755 12 8.48438 17.3126 8.48438 23.25C8.48438 17.3126 11.6932 12 16.2188 12C11.6932 12 8.48438 6.68775 8.48438 0.75Z'
                    fill={`url(#${paint0})`}
                />
                <path
                    d='M17.6252 12C17.6252 14.9693 16.0213 17.625 13.7578 17.625C16.0213 17.625 17.6252 20.2815 17.6252 23.25C17.6252 20.2815 19.2291 17.625 21.4926 17.625C19.2291 17.625 17.6252 14.9693 17.6252 12Z'
                    fill={`url(#${paint1})`}
                />
                <path
                    d='M19.383 0.75C19.383 3.71887 17.7791 6.375 15.5156 6.375C17.7787 6.375 19.383 9.0315 19.383 12C19.383 9.0315 20.9869 6.375 23.2504 6.375C20.9869 6.375 19.383 3.71887 19.383 0.75Z'
                    fill={`url(#${paint2})`}
                />
            </g>
            <defs>
                <linearGradient id={paint0} x1='0.75' y1='0.75' x2='16.2188' y2='23.25' gradientUnits='userSpaceOnUse'>
                    <stop stopColor={theme.ai.gradientStart} />
                    <stop offset='0.5' stopColor={theme.ai.gradientMid} />
                    <stop offset='1' stopColor={theme.ai.gradientEnd} />
                </linearGradient>
                <linearGradient id={paint1} x1='13.7578' y1='12' x2='21.4926' y2='23.25' gradientUnits='userSpaceOnUse'>
                    <stop stopColor={theme.ai.gradientStart} />
                    <stop offset='0.5' stopColor={theme.ai.gradientMid} />
                    <stop offset='1' stopColor={theme.ai.gradientEnd} />
                </linearGradient>
                <linearGradient id={paint2} x1='15.5156' y1='0.75' x2='23.2504' y2='12' gradientUnits='userSpaceOnUse'>
                    <stop stopColor={theme.ai.gradientStart} />
                    <stop offset='0.5' stopColor={theme.ai.gradientMid} />
                    <stop offset='1' stopColor={theme.ai.gradientEnd} />
                </linearGradient>
                <clipPath id={clip}>
                    <rect width='24' height='24' fill='white' />
                </clipPath>
            </defs>
        </svg>
    );
};

export const Sparkles = styled(_sparkles)``;
export default Sparkles;
